import React from 'react';

import { NavLink } from 'react-router-dom';

import '@app/scss/pages/services.scss';
import RequestDemoLinkBlock from '@app/components/UI/components/RequestDemoLinkBlock';

const floridaDMVSolutions = [
	{
		title: 'New Vehicle Registrations',
		text: 'Quick, hassle-free processing of new vehicle paperwork.',
	},
	{
		title: 'Dealership Title & Registration',
		text: ' Dedicated in-house tag & title processors.',
	},
	{
		title: 'Vehicle Title Transfers',
		text: 'Accurate, reliable title transfer services..',
	},
	{
		title: 'VIN Verifications',
		text: 'Convenient on-site compliance checks.',
	},
	{
		title: 'Duplicate Title Services',
		text: 'Swift replacement for lost or damaged titles.',
	},
	{
		title: 'Commercial Fleet Registration',
		text: 'Specialized fleet registration management.',
	},
	{
		title: 'Personalized & Specialty License Plates',
		text: 'Customizable plates to fit customer preferences.',
	},
	{
		title: 'Specialty & Customized Plates',
		text: 'Rapid processing of unique plate requests.',
	},
	{
		title: 'Temporary Tags & Permits',
		text: 'Immediate issuance to keep vehicles road-ready.',
	},
	{
		title: 'Registration Renewals',
		text: 'Easy and timely renewals',
	},
	{
		title: 'Boat Registrations',
		text: 'Efficient handling of registrations, renewals & transfers compliant with Florida regulations.',
	},
	{
		title: 'Mobile Home Titling & Registration',
		text: 'Dedicated expert handling of Mobile Home paperwork.',
	},
	{
		title: 'Mechanic Liens',
		text: 'Expert processing & safeguarding of your lien-related documentation.',
	},
];

const nationwideDMVSolutions = [
	{
		title: 'Accurate Fee Quotes',
		text: <>
			Real-time tax and fee
			<br />
			calculations for every jurisdiction.
		</>,
	},
	{
		title: 'Fast-Track Processing',
		text: <>
			 Expert handling ensuring rapid & precise documentation.
		</>,
	},
	{
		title: 'Real-Time Deal Tracking',
		text: <>
			Complete visibility with interactive dashboards & timely alerts.
		</>,
	},
	{
		title: 'DMS Integration',
		text: <>
			Certified integrations with industry-leading platforms (CDK, Dealertrack, Tekion).
		</>,
	},
	{
		title: 'Pre-Filled Forms & Documentation Guides',
		text: <>
			Streamlined Processes to
			<br />
			prevent costly errors.
		</>,
	},
	{
		title: '24/7 Live Support',
		text: <>
			Accessible, responsive customer
			<br/>
			assistance around the clock.
		</>,
	},
	{
		title: 'Duplicate Titles & Title Corrections',
		text: <>
			Comprehensive title management nationwide.
		</>,
	},
	{
		title: 'Comprehensive Training',
		text: <>
			Customized dealer training programs enhancing your team’s proficiency.
		</>,
	},
	{
		title: 'Compliance Management',
		text: <>
			Ongoing monitoring of state-specific regulatory changes.
		</>,
	},
	{
		title: 'NMVTIS Access',
		text: <>
			Instant vehicle history & regulatory compliance checks.
		</>,
	},
];

const Services: React.FC = () => {
	return (
		<div className="services">
			<div className="top-banner">
				<div className="image-block">
					<picture>
						<source media="(max-width: 600px)" srcSet="/images/service-1.png"/>
						<source media="(max-width: 768px)" srcSet="/images/service-1.png"/>
						<source media="(min-width: 769px)" srcSet="/images/service-1.png"/>
						<img className="top-banner__image" alt="banner" srcSet="/images/service-1.png"/>
					</picture>
					<div className="banner-text">
						<h1>
							Services
						</h1>
						<div className="is-relative">
							<div className="skew-block-right">
								<div className="skew-block blue-border skew-padding-s white-block">
									<p className="text-primary text-primary-big" style={{fontWeight: 500, fontSize: 20}}>
										With <b>30 YEARS OF&nbsp;COMBINED</b><br className="show-mobile"/> expertise, our services stand out for
										their exceptional client service, instant fee estimates, user-friendly platform,
										and easy, straightforward process.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="padding-top-m">
				<div className="skew-block-left dmv-block-first">
					<div className="blue-dark-block skew-block skew-padding-s" style={{ maxWidth: '88vw' }}>
						<h2 className="margin-0">
							Executive Tags<br className="show-mobile" /> DMV Solutions
						</h2>
					</div>
				</div>
				<div className="content-block flex-row dmv-block">
					<p>
						Whether you're a local individual or a dealership, our specialized DMV services streamline your
						operations and enhance your customer experiences.
					</p>
					<div>
						<NavLink to="/contact-us?demo=true" className="button primary-button button-short">
							Request a Demo
						</NavLink>
					</div>
				</div>
			</div>
			<div className="dmv-block-second">
				<div className="skew-padding-text">
					<div className="skew-block-left">
						<div className="skew-block blue-block skew-padding-s">
							<h3 className="margin-0 white-text text-italic">
								<b>Florida DMV Services</b>
								<br/>
								for Florida Residents & Dealerships
							</h3>
						</div>
					</div>
				</div>
				<div className="skew-block blue-dark-border transform-top lines">
					<div className="lines-top"/>
					<div className="lines-bottom"/>
					<div className="content-block" style={{paddingLeft: 260}}>
						<div className="col-2-block">
							{floridaDMVSolutions.map(({text, title}) => <p key={text}>
								<span style={{fontWeight: 600}}>{title}</span>
								<br/>
								{text}
							</p>)}
						</div>
					</div>
				</div>
			</div>
			<div>
				<div className="skew-padding-text dms-block-second">
					<div className="skew-block-right">
						<div className="skew-block blue-block skew-padding-s">
							<div className="content-block">
								<h3 className="margin-0 white-text text-end text-italic">
									<b>Nationwide DMV Solutions&nbsp;</b>
									<br/>
									for Automotive Dealers Across all 50 States
								</h3>
							</div>
						</div>
					</div>
				</div>
				<div className="skew-block blue-dark-border lines">
					<div className="lines-top"/>
					<div className="lines-bottom"/>
					<div className="content-block" style={{paddingLeft: 260}}>
						<div className="col-2-block text-end">
							{nationwideDMVSolutions.map(({text, title}) => <p key={title}>
								<span style={{fontWeight: 600}}>{title}</span>
								<br/>
								{text}
							</p>)}
						</div>
					</div>
				</div>
			</div>
			<RequestDemoLinkBlock
				content={<>
					<h4 className="white-text">
						Empower your dealership with Executive Tags
					</h4>
					<p style={{fontWeight: 400}}>
						Let our experienced team handle the complexities of vehicle titling and registration, so you can dedicate your valuable time
						to serving your customers and growing your business.
					</p>
					<p>
						<b>
							Contact us today—where convenience meets compliance.
						</b>
					</p>
				</>}
			/>
		</div>
	);
};

export default Services;
